module.exports = __webpack_public_path__ + "static/menu-modifiers-b2b764948b03bc902926ccb9515cb7d3.gif";